module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageTextPage":{"breadcrumbs":{"base":"Vše o nákupu"},"verticalMenuLinks":{"ariaLabel":"Menu o nákupu","heading":"O nákupu"}}}}')
  delete Component.options._Ctor
}
